export default "skymp5-front/8155285f08ca2a367a0e6473fc67cd25.png";